import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import Layout from '../components/Layout';
import ShopFilter from '../filters/ShopFilter';
import { RoleAllowBrand } from '../../../auth/roleAware';
import DirtyFilterOverlay from '../components/DirtyFilterOverlay';
import SalesByBarberBrandFilters from '../filters/containers/Filters';
import { t } from '../../../../modules/infra/i18n';

const SalesByBarber = ({ data, columns, fetcher, heading }) => (
  <Layout title={heading || t('reports:sales_by_barber.title')}>
    <div className="c-sales-by-barber-wrapper">
      <div className="c-report-filters u-mb-">
        <div className="u-mr0 large-and-up-mr- u-mb">
          <SalesByBarberBrandFilters
            showCsvExport
            csvJobName="sales-by-barber-report"
            csvModalTitle={t('reports:sales_by_barber.csv_modal_title')}
            disableBarberFilter
            fetcher={fetcher}
          >
            <RoleAllowBrand>
              <ShopFilter />
            </RoleAllowBrand>
          </SalesByBarberBrandFilters>
        </div>
      </div>
      <div className="layout u-position-relative">
        <DirtyFilterOverlay />
        <ReactTable
          display-if={data.length}
          data={data}
          showPagination={false}
          defaultPageSize={500}
          pageSizeOptions={[5, 10, 25, 50, 100, 500, 1000]}
          minRows={0}
          className="c-table-with-sticky-header c-table c-table-new c-table--small c-no-hover u-mt--"
          columns={columns}
          getTrProps={(state, rowInfo) => {
            return {
              'data-automation-id': `dataRow:salesByBarber:${rowInfo.index}`,
            };
          }}
          getTdProps={(state, rowInfo, column) => {
            return {
              'data-automation-id': column.id ? `text:${column.id}` : null,
            };
          }}
        />
      </div>
    </div>
  </Layout>
);

SalesByBarber.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  heading: PropTypes.string,
  fetcher: PropTypes.func.isRequired,
};

SalesByBarber.defaultProps = {
  heading: '',
};

export default SalesByBarber;
